<template>

    <div class="filter-bar">

        <ul class="grid-cols-3">
            <li>
                <router-link :to="{ name: 'order.index' }" custom v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <button @click="navigate" :class="{ 'active': isExactActive }">
                        Orders
                    </button>
                </router-link>
            </li>
            <li>
                <router-link :to="{ name: 'order.item.index' }" custom v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <button @click="navigate" :class="{ 'active': isExactActive }">
                        Order Items
                    </button>
                </router-link>
            </li>
            <li>
                <router-link :to="{ name: 'invoice.index' }" custom v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <button @click="navigate" :class="{ 'active': isExactActive }">
                        Invoices
                    </button>
                </router-link>
            </li>
        </ul>
        <div class="filters grid-cols-6">
            <div class="filter-control col-span-4 xl:col-span-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                <input id="filter_search" type="text" placeholder="Search by Reference or Product" @keyup="submitFilterDelayed" v-model="value.filters.query">
            </div>

            <div class="filter-control col-span-2 xl:col-span-1 pl-6 ml-1 xl:pl-0 xl:ml-0">
                <select id="filter_status" name="status" v-model="value.filters.status" @change="submitFilter">
                    <option :value="null">Status</option>
                    <option :value="status.value" v-for="status in order_statuses">{{ status.name }}</option>
                </select>
            </div>
            <div class="filter-control flex col-span-5 justify-end pl-6 ml-1">
                <div class="pr-2">
                    <span>from:</span>
                </div>
                <div>
                    <input type="date" name="date-filter-start" v-model="value.filters.start_date" @change="submitFilter"  autocomplete="off" placeholder="Choose start date">
                </div>
                <div class="p-2">
                    <span>to:</span>
                </div>
                <div>
                    <input type="date" name="date-filter-end" v-model="value.filters.end_date" @change="submitFilter" autocomplete="off" placeholder="Choose end date">
                </div>
            </div>
            <div class="col-span-1 md:col-span-1 sm:col-span-2 flex-shrink">
                <button class="btn-outline btn-clear-filters py-1 px-1" @click.prevent="resetFilters()">Clear Filters</button>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "OrderIndexFilterBar",
    props: {
        value: {
            type: Object,
            required: true
        },
        timeout_length: {
            type: Number,
            required: false,
            default: 1000
        }
    },
    data() {
        return {
            order_statuses: [
                {
                    value: 'open',
                    name: 'Open',
                },
                {
                    value: 'processing',
                    name: 'Processing',
                },
                {
                    value: 'complete',
                    name: 'Complete',
                },
                {
                    value: 'cancelled',
                    name: 'Cancelled',
                },
                {
                    value: 'failed',
                    name: 'Failed',
                },
            ]
        }
    },
    methods: {
        submitFilterDelayed() {
            let vm = this;

            clearTimeout(vm.timeout);

            vm.timeout = setTimeout(function() {
                vm.submitFilter();
            }, this.timeout_length);
        },
        submitFilter() {
            this.$emit('submitFilter');
        },
        resetFilters() {
            this.$emit('resetFilters');
        },
    },
    mounted() {
        let filters = this.value.filters;
        let d = new Date();
        d.setDate(d.getDate() - 30);
        filters.start_date = d.toISOString().slice(0, 10);
        filters.end_date = new Date().toISOString().slice(0, 10);
    }
}
</script>
